export const meta = {
  title: '服务条款 | gridcraft',
  description:
    '使用 gridcraft 下载资源、安装指南、Excel 功能对比与使用体验内容的相关条款。',
  updated_at: '2026-10-18',
};

## 关于服务

gridcraft（gridcraft.me）提供 GridCraft 下载资源、安装指导、与 Microsoft Excel 的功能对比和使用体验。使用本站即表示您同意本条款及[《可接受使用政策》](/zh/acceptable-use-policy)。信息处理方式见[《隐私政策》](/zh/privacy-policy)。

## 独立网站与商标

本站是独立的信息网站，并非 ArtCraft 或 Microsoft 的官方网站，也未获得两者的背书。GridCraft、ArtCraft、Microsoft 和 Excel 等名称及商标归各自权利人所有。提及产品名称是为了说明所讨论的软件。

## 下载与安装

下载链接可能指向第三方发布页面。安装前，请核对发布者、软件版本、操作系统要求和适用许可。软件本身的使用受其发布者的许可和条款约束。本站指南不会额外授予软件使用权、付费许可证或发布者的技术支持。

安装软件、导入工作簿或执行故障排查步骤前，请备份重要文件。请勿仅为执行指南而关闭安全防护。

## 功能对比与使用体验

指南、对比和评测基于相关内容中说明的版本、环境和测试场景。功能、价格、兼容性和可用性可能发生变化。对比内容不保证工作簿、公式、宏或工作流程在另一款应用中表现完全一致。更换实际工作流程前，请使用您自己的文件副本进行测试。

## 网站工具与账户

本站提供的编辑器或演示工具按现有可用状态提供。请及时保存导出文件，并自行维护备份。如果您创建账户，请提供准确的信息、保护登录凭据，并在发现疑似未经授权的访问时联系我们。您应对提交的数据负责，并拥有使用这些数据的权限。

## 内容与允许的使用

您可以出于合法目的阅读本站内容和分享链接。除非相关许可或适用法律允许，请勿全文转载文章、重新分发素材，或将本站内容冒充为自己的作品。第三方软件与源代码仍受各自许可约束。

## 费用与第三方购买

本条款不为该信息网站设立付费订阅、积分制度或退款承诺。如未来提供付费项目，将在付款前明确说明价格和购买条件。您在第三方平台进行的购买，适用该平台的购买、取消和退款规则。

## 可用性与责任

我们努力提供实用、准确的信息，但网站及内容按现有可用状态提供，不保证信息完整、持续可访问或适合某项特定任务。在适用法律允许的范围内，我们不对因依赖指南、第三方下载或文件兼容问题导致的损失负责。本条款不排除适用法律规定不得排除的权利或责任。

## 滥用处理与变更

我们可能限制滥用访问或移除违法内容，也可能更新内容、链接、功能和本条款。修订日期见页首。如果您认为访问限制或文章内容有误，请联系我们。

## 联系我们

网站问题、内容纠错与使用支持：[support@gridcraft.me](mailto:support@gridcraft.me)。
